import React from "react";
import { SideNavContainer } from "../style";
import { MenuItems } from "../MenuItems";

const SideNav = () => {
  return (
    <SideNavContainer>
      <MenuItems />
    </SideNavContainer>
  );
};

export default SideNav;
